/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Automation_NewInputs */

const cs_settings_automation_new = /** @type {(inputs: Settings_Automation_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový workflow`)
};

const en_settings_automation_new = /** @type {(inputs: Settings_Automation_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New workflow`)
};

/**
* | output |
* | --- |
* | "New workflow" |
*
* @param {Settings_Automation_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_automation_new = /** @type {((inputs?: Settings_Automation_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Automation_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_automation_new(inputs)
	return cs_settings_automation_new(inputs)
});